import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const IconSandglass: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M6.11108 4.44434H13.8889"
                stroke="currentColor"
                strokeWidth="1.11111"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.22223 4.44434V6.76211C7.22229 7.05677 7.3394 7.33934 7.54778 7.54767L10 9.99989L12.4522 7.54767C12.6606 7.33934 12.7777 7.05677 12.7778 6.76211V4.44434"
                stroke="currentColor"
                strokeWidth="1.11111"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.7778 15.5556V13.2378C12.7777 12.9431 12.6606 12.6605 12.4522 12.4522L10 10L7.54778 12.4522C7.3394 12.6605 7.22229 12.9431 7.22223 13.2378V15.5556"
                stroke="currentColor"
                strokeWidth="1.11111"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.11108 15.5557H13.8889"
                stroke="currentColor"
                strokeWidth="1.11111"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
